import { adminApi } from '../../../../store/generated/admin/employee-record-values';
import { UserContextApiTags } from '../../../../common/api/userContextApi';

export const EmployeeRecordValueApiTags = {
  EmployeeRecordValue: 'EmployeeRecordValue',
} as const;

const taggedApi = adminApi.enhanceEndpoints({addTagTypes: Object.values(EmployeeRecordValueApiTags),});

export const employeeRecordApi = taggedApi.enhanceEndpoints({
  addTagTypes: [
    EmployeeRecordValueApiTags.EmployeeRecordValue,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1EmployeeRecordValuesList: {
      providesTags: [EmployeeRecordValueApiTags.EmployeeRecordValue],
    },
    apiAdminV1EmployeeRecordValuesCreate: {
      invalidatesTags: [
        EmployeeRecordValueApiTags.EmployeeRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1EmployeeRecordValuesRetrieve: {
      providesTags: [EmployeeRecordValueApiTags.EmployeeRecordValue],
    },
    apiAdminV1EmployeeRecordValuesUpdate: {
      invalidatesTags: [
        EmployeeRecordValueApiTags.EmployeeRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1EmployeeRecordValuesDestroy: {
      invalidatesTags: [
        EmployeeRecordValueApiTags.EmployeeRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
  },
});